import { component } from 'picoapp';
import Modal from 'utils/components/modal';
import SwiperClass from 'swiper/types/swiper-class';
import { SwiperOptions } from 'swiper/types/swiper-options';

export default component(async (node) => {
  const sliderElement = node.querySelector<HTMLElement>('[data-lightbox-slider]');
  const prev = node.querySelector<HTMLButtonElement>('[data-prev]');
  const next = node.querySelector<HTMLButtonElement>('[data-next]');
  const modal = Modal(node);

  let swiperSlider: SwiperClass;
  let index = 0;

  document.addEventListener('click', (e) => {
    const target = e.target as HTMLElement;
    const trigger = target.closest<HTMLElement>('[data-lightbox]');
    const close = target.closest<HTMLButtonElement>('[data-close]');
    const zoom = target.closest<HTMLButtonElement>('[data-zoom]');

    if (trigger) {
      modal.open();
      index = parseInt(trigger.dataset.lightbox, 10);
    }

    if (zoom) {
      modal.open();
      const activeImageIndex = document.querySelector<HTMLElement>('.swiper-slide-thumb-active');
      if (activeImageIndex) {
        index = parseInt(activeImageIndex.dataset.lightboxIndex, 10);
      }
    }

    if (close) {
      modal.close();
    }
  });

  modal.on('open', async () => {
    const Swiper = (await import(
      /* webpackChunkName: "swiper" */
      'modules/swiper'
    )).default;

    swiperSlider = new Swiper(sliderElement, {
      slidesPerView: 1,
      keyboard: {
        enabled: true,
        onlyInViewport: true,
      },
      navigation: {
        prevEl: prev,
        nextEl: next,
      },
    } as SwiperOptions);

    swiperSlider.init();
    swiperSlider?.slideTo(index, 0);
  });
});
